<template>
	<div>
		<h4 class="text-center">White Label</h4>
		<b-form-row >
			<b-form-group class="col-md-2" label="Fecha reserva desde *">
				<b-form-datepicker
					locale="es"
					:class="{
						'active-filter': filters.reservationStartDate
					}"
					required
					reset-button
					size="md"
					v-model="filters.reservationStartDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-2" label="Fecha de reserva hasta *">
				<b-form-datepicker
					locale="es"
					:class="{
						'active-filter': filters.reservationEndDate
					}"
					required
					reset-button
					size="md"
					v-model="filters.reservationEndDate"
				/>
			</b-form-group>
			<b-form-group class="col-md-2" label="Fecha servicio desde">
				<b-form-datepicker
					locale="es"
					:class="{
						'active-filter': filters.pickupStartDate
					}"
					reset-button
					size="md"
					v-model="filters.pickupStartDate"
				/>
			</b-form-group>

			<b-form-group class="col-md-2" label="Hasta">
				<b-form-datepicker
					locale="es"
					:class="{ 'active-filter': filters.pickupEndDate }"
					reset-button
					size="md"
					v-model="filters.pickupEndDate"
				/>
			</b-form-group>


			<b-form-group class="col-md-2" label="Punto de venta">
				<multiselect
					:class="{
						'active-filter': filters.pointOfSalesIds.length > 0
					}"
					placeholder="Seleccionar opcion"
					group-label="group"
					group-values="options"
					group-select
					v-model="filters.pointOfSalesIds"
					:options="pointOfSalesOpts"
					label="text"
					multiple
					track-by="value"
					taggable
				/>
			</b-form-group>
			<b-form-group class="col-md-2" label="Estado de servicio">
				<multiselect
					:class="{
						'active-filter': filters.status.length > 0
					}"
					v-model="filters.status"
					:options="statusOpts"
					group-label="group"
					group-values="options"
					group-select
					multiple
					label="text"
					track-by="value"
					placeholder="Todos"
					taggable
				>
				</multiselect>
			</b-form-group>
		</b-form-row>

		<b-form-row>
			<b-overlay :show="loadingExport" no-wrap rounded> </b-overlay>
			<b-col class="text-right mt-2">
				<b-button
					v-if="$hasPermission('report.show')"
					@click="searchWhiteLabel()"
					variant="primary"
					class="mr-2"
					><md-icon icon="search" /> Generar</b-button
				>
			</b-col>
		</b-form-row>

		<b-table :fields="fields" :items="whiteLabelItems" :busy="loading" class="mt-4">
			<template #cell(transactions)="{item}">
				<div class="d-flex justify-content-end align-items-center">
					<span
						v-if="item.transactionsDiff"
						:class="getStyle(item, 'transactions').class"
						class="d-flex flex-align-center mr-2"
					>
						<small>
							<b>
								<md-icon
									:icon="getStyle(item, 'transactions').icon"
								></md-icon>
								{{ formatCurrency(item.transactionsDiff) }} %
							</b>
						</small>
					</span>
					<span>{{ formatCurrency(item.transactions) }}</span>
				</div>
			</template>
			<template #cell(totalAmount)="{item}">
				<div class="d-flex justify-content-end align-items-center">
					<span
						v-if="item.totalAmountDiff"
						:class="getStyle(item, 'totalAmount').class"
						class="d-flex flex-align-center mr-2"
					>
						<small>
							<b>
								<md-icon
									:icon="getStyle(item, 'totalAmount').icon"
								></md-icon>
								{{ formatCurrency(item.totalAmountDiff) }} %
							</b>
						</small>
					</span>
				<span>{{ formatCurrency(item.totalAmount) }}</span>
				</div>
			</template>
			<template #cell(currency)="{item}">
				<span>{{ toUpperCase(item.currency) }}</span>
			</template>
			<template #custom-foot>
				<tr>
					<td><b>Total</b></td>
					<td class="text-right">
						<div class="d-flex justify-content-end align-items-center">
							<span
								v-if="totalForComparison"
								:class="getStyle(totalForComparison, 'transactions').class"
								class="d-flex flex-align-center mr-2"
								>
								<small>
									<b>
										<md-icon :icon="getStyle(totalForComparison, 'transactions').icon"></md-icon>
										{{ formatCurrency(totalForComparison.transactionsDiff) }} %
									</b>
								</small>
							</span>
							<b>{{ formatCurrency(total.transactions) }}</b>
						</div>
					</td>
					<td class="text-right">
						<div class="d-flex justify-content-end align-items-center">
							<span
								v-if="totalForComparison"
								:class="getStyle(totalForComparison, 'totalAmount').class"
								class="d-flex flex-align-center mr-2"
								>
								<small>
									<b>
										<md-icon :icon="getStyle(totalForComparison, 'totalAmount').icon"></md-icon>
										{{ formatCurrency(totalForComparison.totalAmountDiff) }} %
									</b>
								</small>
							</span>
							<b>{{ formatCurrency(total.totalAmount) }}</b>
						</div>
					</td>
					<td class="text-right"><b>USD</b></td>
				</tr>
			</template>
			<template #table-busy>
				<div class="text-center text-danger my-2">
					<b-spinner class="align-middle"></b-spinner>
					<strong>Loading...</strong>
				</div>
			</template>
		</b-table>
	</div>
</template>

<script>
import api from "../../../../api.js";
import Multiselect from "vue-multiselect";
import moment from "moment";
export default {
	name: "comercial",
	components: {
		Multiselect
	},
	data() {
		return {
			loading: false,
			loadingExport: false,
			filters: {
				pointOfSalesIds: [],
				status: [],
				pickupStartDate: "",
				pickupEndDate: "",
				reservationStartDate: moment().startOf('month').format('YYYY-MM-DD'),
				reservationEndDate: moment().format("YYYY-MM-DD")
			},
			fields: [
				{
					key: "whiteLabel",
					label: "White Label",
					sortable: true
				},
				{
					key: "transactions",
					label: "Transacciones",
					class: "text-right",
					sortable: true
				},
				{
					key: "totalAmount",
					label: "Monto",
					class: "text-right",
					sortable: true
				},
				{
					key: "currency",
					class: "text-right",
					label: "Moneda"
				}
			],
			total: {
				transactions: 0,
				totalAmount: 0
			},
			totalForComparison: null,

			whiteLabelItems: [],
			whiteLabelItemsForComparison: []
		};
	},
	methods: {
		getStyle(item, type) {
			return {
				class: item[`${type}Diff`] < 0
					? "text-danger"
					: "text-success",
				icon: item[`${type}Diff`] < 0
					? "south"
					: "north"
			};
		},
		fetchWhiteLabels(filters) {
			return api(this).get(`/reports/white-labels`, {
				params: {
					filters
				}
			});
		},

		toUpperCase(currency) {
			return currency.toUpperCase();
		},

		formatCurrency(value) {
			if (value === undefined) return "";
			return Intl.NumberFormat("en-US").format(Number(value.toFixed(1)));
		},

		getTotal(data) {
			return data.reduce(
				(acc, curr) => {
					return (acc = {
						transactions: acc.transactions + curr.transactions,
						totalAmount: acc.totalAmount + curr.totalAmount
					});
				},
				{ transactions: 0, totalAmount: 0 }
			);
		},

		getFilters() {
			const aux = {
				...this.filters,
				pointOfSalesIds: this.filters.pointOfSalesIds.map(
					({ value }) => value
				),
				status: this.filters.status.map(({ value }) => value)
			};

			const reservationStartDate = moment(
				this.filters.reservationStartDate
			);
			const reservationEndDate = moment(this.filters.reservationEndDate);

			const diff = reservationEndDate.diff(reservationStartDate, "days");

			const reservationEndDateComparision = reservationStartDate
				.subtract(1, "days")
				.format("YYYY-MM-DD");
			const reservationStartDateComparision = moment(
				reservationStartDate.format()
			)
				.subtract(diff, "days")
				.format("YYYY-MM-DD");

			return {
				filters: aux,
				filtersForComparision: {
					...aux,
					reservationStartDate: reservationStartDateComparision,
					reservationEndDate: reservationEndDateComparision
				}
			};
		},

		getDiff:(oldValue, newValue) => ((oldValue - newValue) / newValue) * 100,

		validate() {
			try {
				if(!this.filters.reservationStartDate) {
					throw 'Fecha reserva desde* es requerido'
				}
				if(!this.filters.reservationEndDate) {
					throw 'Fecha reserva hasta* es requerido'
				}
				return true
			} catch (error) {
				this.$root.showAlert(error,{variant:'danger'})
				return false
			}
		},

		searchWhiteLabel() {
			if(this.validate()) {
			this.loading = true;
			const { filters, filtersForComparision } = this.getFilters();
			this.whiteLabelItems = []
			this.whiteLabelItemsForComparison = []
			this.total = {
				transactions: 0,
				totalAmount: 0
			}
			this.totalForComparison = null
			this.fetchWhiteLabels(filters)
				.then(({ data }) => {
					this.whiteLabelItems = data;
					this.total = this.getTotal(data);
					this.fetchWhiteLabels(filtersForComparision).then(res => {
						this.whiteLabelItems = this.whiteLabelItems.map(
							item => {
								const whiteLabelComparision = res.data.find(
									({ whiteLabelId }) =>
										whiteLabelId === item.whiteLabelId
								);
								if (!whiteLabelComparision){
									return { ...item }
								} else {
								this.whiteLabelItemsForComparison.push(whiteLabelComparision)
								const {
									transactions,
									totalAmount
								} = whiteLabelComparision;
								return {
									...item,
									transactionsDiff: this.getDiff(item.transactions, transactions),
									totalAmountDiff: this.getDiff(item.totalAmount, totalAmount)
								};
								}
							}
						);

						const {transactions, totalAmount} = this.getTotal(this.whiteLabelItemsForComparison)
						this.totalForComparison = {
							transactionsDiff: this.getDiff(this.total.transactions, transactions),
							totalAmountDiff: this.getDiff(this.total.totalAmount, totalAmount)
						}
					});
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				})
				.finally(() => {
					this.loading = false;
				});
				}
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["pointOfSalesOpts"]
		});
	},
	computed: {
		pointOfSalesOpts() {
			return [ {
					group: "SELECT ALL",
					options: this.$root.auxVars.pointOfSalesOpts
				} ]
		},
		statusOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.transportServiceStatusOpts
				}
			];
		}
	}
};
</script>

<style scoped></style>
